import { render, staticRenderFns } from "./uploadModel.vue?vue&type=template&id=c8fcee82"
import script from "./uploadModel.vue?vue&type=script&lang=js"
export * from "./uploadModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports